import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=a0276214&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"
import style0 from "./bar.vue?vue&type=style&index=0&id=a0276214&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0276214",
  null
  
)

export default component.exports